import React, { useEffect } from "react";

const ZendeskWidget = (props) => {

  const { siteInfo, loadingSiteInfo } = props;

  const neoKey = "2102aebf-6fd1-48a1-b89f-5f67662b2b54";
  const scKey = "e1560d88-fb00-4a6e-8f3e-2dbc2c674383";


  const siteCode = siteInfo?.siteInfo?.code;


  useEffect(() => {
    if (document.getElementById("ze-snippet")) {
      return;
    }
    const script = document.createElement("script");

    script.id = "ze-snippet";
    script.src =
      `https://static.zdassets.com/ekr/snippet.js?key=${siteCode === "inf" ? neoKey : scKey}`;
    script.async = true

    if (!loadingSiteInfo) {
      document.body.appendChild(script);
    };

  }, [loadingSiteInfo]);

  const openChat = () => {
    if (window.zE) {
      window.zE("messenger", "open");
    }
  };

  return (
    <button className="zd-chat-button" onClick={openChat}>
      Chat with us
    </button>
  )
}

export default ZendeskWidget;
